import { render, staticRenderFns } from "./EzObserver.vue?vue&type=template&id=4c52d0f4&"
import script from "./EzObserver.vue?vue&type=script&lang=js&"
export * from "./EzObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports